<h4 class="page-title">{{TR "Gesamtübersicht"}}</h4>
{{#if this.message}}
    {{{this.message}}}
{{else}}
    <div class="row m-t-10">
        <div class="col-lg-12">
            <div class="card-box clearfix">
                <div class="row">
                    <div class="col-xs-12 col-sm-6">
                        <div class="control-label">
                            <label>{{TR "Gerätename"}}</label>
                            <input
                                type="text"
                                class="form-control input-sm"
                                id="overview-device-filter"
                                value="{{deviceFilter}}"
                            />
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <div class="control-label">
                            <label>{{TR "Daten"}}</label>
                            <input
                                type="text"
                                class="form-control input-sm"
                                id="overview-value-filter"
                                value="{{valueFilter}}"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="overviewContent">
    </div>
{{/if}}

